import { Flex } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { ResponsiveChangeUserDataWidget } from "src/widgets";

import css from "./ProfilePage.module.scss";
import {
  PoizonAccountsWidget,
  PoizonApiKeysWidget,
  SubscribeDataWidget,
  UserDataWidget,
} from "./widgets";

export const ProfilePage = () => {
  const { isMobile } = useGravityDevice();
  return (
    <Flex style={{ flexDirection: !isMobile ? "row" : "column" }}>
      <div className={css.tabContainer}>
        <Flex direction={"column"} gap={8}>
          <Flex wrap={"wrap"} gap={8}>
            <UserDataWidget />
            <SubscribeDataWidget />
            <ResponsiveChangeUserDataWidget />
          </Flex>
          <PoizonApiKeysWidget />
          <PoizonAccountsWidget />
        </Flex>
      </div>
    </Flex>
  );
};
